import { useEffect, useState } from 'react'

interface Star {
    id: number
    top: number
    left: number
    size: number
    animationDuration: number
    delay: number
    opacity: number
}

export default function StarsEffect() {
    const [stars, setStars] = useState<Star[]>([])

    useEffect(() => {
        // Generate stars only on client side
        const count = 40 // Số lượng sao (giảm từ 100 để tối ưu performance)
        const newStars: Star[] = []

        for (let i = 0; i < count; i++) {
            newStars.push({
                id: i,
                top: Math.random() * 100, // percentage
                left: Math.random() * 100, // percentage
                size: 1 + Math.random() * 2, // 1-3px
                animationDuration: 2 + Math.random() * 3, // 2-5s
                delay: Math.random() * 2, // 0-2s delay
                opacity: 0.2 + Math.random() * 0.5, // 0.2-0.7
            })
        }

        setStars(newStars)
    }, [])

    return (
        <div className="fixed inset-0 pointer-events-none z-[0] overflow-hidden" aria-hidden="true">
            {stars.map((star) => (
                <div
                    key={star.id}
                    className="absolute rounded-full bg-white shadow-[0_0_2px_#fff]"
                    style={{
                        top: `${star.top}%`,
                        left: `${star.left}%`,
                        width: `${star.size}px`,
                        height: `${star.size}px`,
                        opacity: star.opacity,
                        animation: `twinkle ${star.animationDuration}s infinite ease-in-out ${star.delay}s`,
                    }}
                />
            ))}
            <style>{`
        @keyframes twinkle {
          0%, 100% { opacity: 0.2; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.2); box-shadow: 0 0 4px #fff, 0 0 8px #fcd34d; }
        }
      `}</style>
        </div>
    )
}
